/**
 * SDS SDK configuration — appId / sign are runtime-fetched from the
 * /api/sdk/sign endpoint and never hardcoded.
 */

import { CONFIG } from '../../../core/config.js'
import { createLogger } from '../../../utils/logger.js'

const log = createLogger('sds-config')

/**
 * SDS credential cache — populated by fetchSdsSign()
 * These are runtime-fetched signing tokens, not static keys.
 */
export const SDS_CONFIG = {
  appId: null,
  sign: null,
}

/**
 * Fetch SDS SDK signing credentials from backend.
 *
 * ANONYMOUS by product design — anyone can open the Design canvas; login is
 * required only at publish. Contract:
 * docs/best-practice/03_sds-designer-sdk-contract.md (bao 2026-06-05).
 * @returns {Promise<{appId: string, sign: string}>}
 */
export async function fetchSdsSign() {
  log.info('Fetching SDK signing credentials from backend...')
  const res = await fetch(`${CONFIG.SDS_API}/api/sdk/sign`)
  const data = await res.json()
  if (!data.success) throw new Error(data.error || 'Failed to fetch SDK signing credentials')
  SDS_CONFIG.appId = data.appId
  // Backend returns field as "secret" — store as sign token
  SDS_CONFIG.sign = data.secret
  log.info('SDK signing credentials fetched:', { appId: SDS_CONFIG.appId })
  return data
}
